import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { patientService } from '../../services/api'
import { Patient } from '../../models/Patient.model'

const initialState = {
  patients: {},
  loading: false,
  error: null
}

export const fetchPatients = createAsyncThunk(
  'patients/fetchPatients',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await patientService.getAll(filters)
      return response.data.patients.map(p => Patient.FromObj(p))
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch patients')
    }
  }
)

export const createPatient = createAsyncThunk(
  'patients/createPatient',
  async (patientData, { rejectWithValue }) => {
    try {
      const response = await patientService.create(patientData)
      return Patient.FromObj(response.data)
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create patient')
    }
  }
)

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatients.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.loading = false
        state.patients = {}
        action.payload.forEach(patient => {
          state.patients[patient.id] = patient
        })
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      .addCase(createPatient.fulfilled, (state, action) => {
        state.patients[action.payload.id] = action.payload
      })
  }
})

export const { clearError } = patientsSlice.actions
export const selectPatients = (state) => state.patients.patients
export const selectPatientsLoading = (state) => state.patients.loading
export const selectPatientsError = (state) => state.patients.error

export default patientsSlice.reducer 